import { Directive, ElementRef, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
    selector: '[clickOutside]',
    standalone: true,
})
export class SeClickOutsideDirective {
    // data members
    wasInside = false;

    @Output() clickOutside: EventEmitter<any> = new EventEmitter();

    // constructor

    constructor(private elementRef: ElementRef) {}

    // public functions

    @HostListener('click')
    clickInside() {
        this.wasInside = true;
    }

    @HostListener('document:click', ['$event.target'])
    public onClick(targetElement) {
        if (!this.wasInside) {
            this.clickOutside.emit(targetElement);
        }
        this.wasInside = false;
    }
}
